import toast from "react-hot-toast";

export default (error: any) => {
  toast.error('Sorry! Server Error. Please try again.', {
    position: 'top-left',
    duration: 5000,
  });
}